var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog"},[_c('div',{staticClass:"sidebar"},[_c('ul',_vm._l((_vm.postToc),function(t){return _c('li',{key:t.id,on:{"click":function($event){_vm.getPost(t.id)}}},[_c('router-link',{attrs:{"active-class":"active","to":("/blog/" + (t.id))}},[_vm._v("\n        "+_vm._s(t.title)+"\n        ")])],1)}))]),_c('div',{staticClass:"content-wrap"},[_c('BlogContent')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4422c05c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blog.vue
// module id = null
// module chunks = 